import React, { useState } from 'react';
import { db } from '../firebase';
import { doc, updateDoc, Timestamp } from 'firebase/firestore';

export default function EditUser({ user, onClose }) {
  const [form, setForm] = useState({ ...user });
  const [validity, setValidity] = useState(
    user.validity?.toDate ? user.validity.toDate().toISOString().split('T')[0] : ''
  );

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const updateData = { ...form };
    if (validity) {
      updateData.validity = Timestamp.fromDate(new Date(validity));
    }
    await updateDoc(doc(db, 'users', user.id), updateData);
    onClose();
  };

  return (
    <form onSubmit={handleSave} style={{ background: '#eee', padding: 20, marginBottom: 20 }}>
      <h3>Edit User</h3>
      <input name="name" value={form.name} onChange={handleChange} placeholder="Name" style={{ marginRight: 10 }} />
      <input name="email" value={form.email} onChange={handleChange} placeholder="Email" style={{ marginRight: 10 }} />
      <input name="mobile" value={form.mobile} onChange={handleChange} placeholder="Mobile" style={{ marginRight: 10 }} />
      <input name="category" value={form.category} onChange={handleChange} placeholder="Category" style={{ marginRight: 10 }} />
      <label style={{ marginRight: 5 }}>Validity:</label>
      <input type="date" value={validity} onChange={(e) => setValidity(e.target.value)} style={{ marginRight: 10 }} />
      <button type="submit">Save</button>
      <button type="button" onClick={onClose} style={{ marginLeft: 10 }}>Cancel</button>
    </form>
  );
}